export enum IdentityProvidersType {
    ServiceMax = 'SERVICE_MAX'
};

export const IdentityProviders: {label: string, value: string}[] =  [
    { value: 'SERVICE_MAX', label: 'Service Max' }
];